'use strict';

jQuery($ => {
	let panelHeader = $('.gecko-panel-header');

	// Find the body header
	const headers = $('[data-fixed-header]');
	headers.each((i, el) => {
		const header = $(el);

		const targetHeader = $('.gecko-page__header .page-header');
		if (!targetHeader.find('.fixed-header-padding').length) {
			targetHeader.prepend('<div class="fixed-header-padding"></div>');
		}

		if (header.is(':visible')) {
			setFillerHeight(header);
		}

		$(window).resize(() => {
			if (header.is(':visible')) {
				setFillerHeight(header);
			}
		});
		$(window).load(() => {
			if (header.is(':visible')) {
				setFillerHeight(header);
			}
		});
	});

	function setFillerHeight(header) {
		if (panelHeader.length) {
			panelHeader.css({
				top: header.outerHeight(),
			});
		}

		// console.log('Setting filler height: ', header.outerHeight());

		$('.gecko-page__header .page-header .fixed-header-padding').each((i, filler) => {
			$(filler).css({
				height: header.outerHeight()
			});
		});
	}
});